var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "margin-top": "40px",
      "margin-left": "40px",
      "font-weight": "600"
    }
  }, [_vm._v("物品管理")]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "9px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "750px",
      "background-color": "#FFFFFF",
      "margin": "0px 40px"
    }
  }, [_c('el-row', {
    staticStyle: {
      "padding-left": "46px",
      "padding-top": "40px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('span', [_vm._v("物品名称")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "65%",
      "margin-left": "10px"
    },
    attrs: {
      "placeholder": "请输入物品名称"
    },
    model: {
      value: (_vm.condition.goods_name),
      callback: function($$v) {
        _vm.$set(_vm.condition, "goods_name", $$v)
      },
      expression: "condition.goods_name"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "span": 4
    }
  }, [_c('span', [_vm._v("物品编号")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "65%",
      "margin-left": "10px"
    },
    attrs: {
      "placeholder": "请输入物品编号"
    },
    model: {
      value: (_vm.condition.goods_no),
      callback: function($$v) {
        _vm.$set(_vm.condition, "goods_no", $$v)
      },
      expression: "condition.goods_no"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "span": 4
    }
  }, [_c('span', [_vm._v("规格型号")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "65%",
      "margin-left": "10px"
    },
    attrs: {
      "placeholder": "请输入规格型号"
    },
    model: {
      value: (_vm.condition.goods_model),
      callback: function($$v) {
        _vm.$set(_vm.condition, "goods_model", $$v)
      },
      expression: "condition.goods_model"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "span": 4
    }
  }, [_c('span', [_vm._v("物品类型")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "65%",
      "margin-left": "10px"
    },
    attrs: {
      "placeholder": "请选择物品类型",
      "clearable": ""
    },
    model: {
      value: (_vm.condition.type_id),
      callback: function($$v) {
        _vm.$set(_vm.condition, "type_id", $$v)
      },
      expression: "condition.type_id"
    }
  }, _vm._l((_vm.lxList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.data,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "85px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    },
    on: {
      "click": _vm.Find
    }
  }, [_vm._v("\n                                查询")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "85px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    },
    on: {
      "click": function($event) {
        return _vm.Del(null)
      }
    }
  }, [_vm._v("\n                                删除")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "85px",
      "border": "1px solid #006E4B",
      "color": "#006E4B"
    },
    on: {
      "click": _vm.AddFrom
    }
  }, [_vm._v("\n                                新增")])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin": "0px 2%",
      "margin-top": "10px"
    }
  }, [_c('el-row', [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "header-cell-style": {
        background: '#F0F0F0',
        color: '#000000'
      },
      "row-class-name": _vm.tableRowClassName,
      "data": _vm.tableData,
      "height": "595",
      "tooltip-effect": "dark"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "序号"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope_1) {
        return [_vm._v(_vm._s(scope_1.$index + 1))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "goods_name",
      "align": "center",
      "label": "物品名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "goods_no",
      "align": "center",
      "label": "物品编号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type_name",
      "align": "center",
      "label": "物品类型"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "goods_model",
      "align": "center",
      "label": "规格型号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "model_quantity",
      "align": "center",
      "label": "物品数量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "model_colour",
      "align": "center",
      "label": "颜色"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "model_weight",
      "align": "center",
      "label": "重量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "model_brand",
      "align": "center",
      "label": "品牌"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          attrs: {
            "src": require("../../../assets/编辑.png")
          },
          on: {
            "click": function($event) {
              return _vm.Edit(scope.row)
            }
          }
        }), _vm._v(" "), _c('img', {
          attrs: {
            "src": require("../../../assets/删除.png")
          },
          on: {
            "click": function($event) {
              return _vm.Del(scope.row.id)
            }
          }
        })]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "10px",
      "text-align": "center"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "page-size": _vm.page_size,
      "layout": " prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)], 1)])], 1), _vm._v(" "), _c('div', [_c('el-dialog', {
    attrs: {
      "title": _vm.dialogTitle,
      "visible": _vm.dialogVisible,
      "width": "30%",
      "close-on-click-modal": false,
      "center": true
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('add', {
    ref: "add"
  })], 1)], 1)])
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3eb32758","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xzgl/WpGl/WpGl.vue
// module id = null
// module chunks = 